import { render } from "./Order.vue?vue&type=template&id=05044827&scoped=true&ts=true"
import script from "./Order.vue?vue&type=script&lang=ts"
export * from "./Order.vue?vue&type=script&lang=ts"

import "./Order.vue?vue&type=style&index=0&id=05044827&scoped=true&lang=css"

import exportComponent from "/Users/jonas/Developer/Fliegen/KantineV2/webapp/shop-webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05044827"]])

export default __exports__